<template>
  <div :class="classes">
    <div>
      <donut-chart :chart-data="chartData" :options="options" />
    </div>
    <span v-if="value" class="value">{{ value }}</span>
  </div>
</template>
<script>
import DonutChart from "./charts/DonutChart";
export default {
  name: "bx-donut-chart",
  components: {
    DonutChart
  },
  props: {
    chartData: {
      type: Object,
      required: true
    },
    value: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: true,
        legend: {
          position: "bottom"
        }
      }
    };
  },
  computed: {
    classes() {
      const classes = ["bx-donut-chart"];
      return classes;
    }
  }
};
</script>
